export default __webpack_public_path__ + "static/media/link.0f837005.svg";